<template>
  <div>
    <div class="page-actions">
      <span>币种： </span>
      <el-select v-model="coinType" placeholder="请选择币种">
        <el-option
          v-for="item in coinList"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <span>时间： </span>
      <el-date-picker
        v-model="times"
        type="daterange"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>
      <el-button type="primary" @click="search({ page: 1 })">搜索</el-button>
      <a :href="downloadLink" target="_blank">导出Excel</a>
    </div>
    <div class="counts">
      <span></span>
      <span>总数：</span>
      <span>{{ count.sumNumber }}</span>
      <span>{{ count.sumGetNumber }}</span>
      <span>{{ count.countNumber }}</span>
      <span>{{ count.countGetNumber }}</span>
      <span>{{ count.userNumber }}</span>
      <span>{{ count.maxUser }}</span>
    </div>
    <el-table :data="currencies">
      <el-table-column prop="cretaeTime" label="时间"></el-table-column>
      <el-table-column prop="coinType" label="币种"></el-table-column>
      <el-table-column prop="sumNumber" label="总充值数量"></el-table-column>
      <el-table-column
        prop="sumGetNumber"
        label="总充值到账数量"
      ></el-table-column>
      <el-table-column prop="countNumber" label="总充值笔数"></el-table-column>
      <el-table-column
        prop="countGetNumber"
        label="总充值成功笔数"
      ></el-table-column>
      <el-table-column prop="userNumber" label="总充值人数"></el-table-column>
      <el-table-column
        prop="maxUser"
        label="充值用户最多的用户ID"
      ></el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="pageChanged"
    ></pagination>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import qs from 'qs';
import Pagination from 'components/pagination';

export default {
  name: 'tradeStatistics',
  data() {
    return {
      times: [],
      coinType: ''
    };
  },

  computed: {
    ...mapState('recharge', [
      'currencies',
      'pagination',
      'totalCount',
      'coinList',
      'count'
    ]),
    startTime() {
      return this.times ? this.times[0] : '';
    },
    endTime() {
      return this.times ? this.times[1] : '';
    },
    downloadLink() {
      const data = {
        startTime: this.startTime,
        endTime: this.endTime,
        status: 1,
        coinType: this.coinType,
        type: 1
      };
      const params = qs.stringify(data);
      return `/la/admin/statistics/withdrawMoney?${params}`;
    }
  },
  methods: {
    ...mapActions('recharge', ['list']),
    ...mapMutations('recharge', ['setpage']),
    search(data) {
      this.list({
        startTime: this.startTime,
        coinType: this.coinType,
        endTime: this.endTime,
        type: 1,
        ...this.pagination,
        ...data
      });
    },
    pageChanged(pagination) {
      this.setpage(pagination);
      this.$emit('refresh', { pagination, type: 1 });
    }
  },
  components: {
    Pagination
  }
};
</script>

<style lang="less" scoped>
.el-table {
  ::v-deep.cell {
    text-align: center;
  }
}
.counts {
  display: flex;
  border: 1px solid #ddd;
  span {
    width: 12.5%;
    line-height: 45px;
    border-right: 1px solid #ddd;
    text-align: center;
  }
}
</style>
